import { useEffect } from 'react';
import { useUser } from '@clerk/clerk-react';
import * as Sentry from '@sentry/react';

export function SentryUserSync() {
  const { isLoaded, isSignedIn, user } = useUser();

  useEffect(() => {
    if (!isLoaded) return;
    if (isSignedIn && user) {
      Sentry.setUser({
        id: user.id,
      });
    } else {
      Sentry.setUser(null);
    }
  }, [isLoaded, isSignedIn, user]);

  return null;
}
